<template>
  <button
    class="review-like-button"
    :class="{ 'is-selected': isSelected, 'is-loading': isLoading }"
    type="button"
    :aria-pressed="String(isSelected)"
    :disabled="disabled || isLoading"
    @click="toggle"
  >
    <span class="icon" v-html="LikeOutline"></span>

    <span v-if="label && !isSelected" class="label">{{ label }}</span>
    <span v-if="localCount !== null && localCount !== undefined && localCount > 0" class="count">{{ localCount }}</span>
  </button>
</template>

<script>
import gql from 'graphql-tag';
import ToggleSurveyLikeMutation from 'assets/graphql/queries/survey/ToggleSurveyLike.graphql';
import LikeOutline from 'assets/icons/Like_outline.svg';

export default {
  name: 'ReviewLikeButton',
  data() {
    return {
      LikeOutline,
      isLoading: false,
      localIsLiked: this.value,
      localCount: this.count,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Útil',
    },
    count: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    surveyId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    isSelected() {
      return this.localIsLiked;
    },
  },
  watch: {
    value(newValue) {
      this.localIsLiked = newValue;
    },
    count(newValue) {
      this.localCount = newValue;
    },
  },
  methods: {
    async toggle() {
      if (this.disabled || this.isLoading) return;

      this.isLoading = true;

      try {
        const { data } = await this.$apollo.mutate({
          mutation: gql`${ToggleSurveyLikeMutation}`,
          variables: {
            survey_id: this.surveyId,
          },
        });

        if (data?.toggle_survey_like?.survey) {
          const survey = data.toggle_survey_like.survey;
          this.localIsLiked = survey.is_liked;
          this.localCount = survey.likes_count;
        } else if (data?.toggle_survey_like?.errors) {
          console.error('Error toggling like:', data.toggle_survey_like.errors);
        }
      } catch (error) {
        console.error('Error executing mutation:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.review-like-button {
  display: inline-flex;
  align-items: end;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #e6e6f0;
  background: #ffffff;
  color: #5858DA; /* default text/icon */
  font: inherit;
  line-height: 1;
  cursor: pointer;
  transition: background-color 160ms ease, color 160ms ease, border-color 160ms ease,
    box-shadow 160ms ease;
}

.review-like-button .icon {
  width: 20px;
  height: 20px;
}

.review-like-button .label {
  font-weight: 600;
}

.review-like-button .count {
  margin-left: 2px;
  color: #5858DA;
  font-weight: 600;
}

/* Hover state */
.review-like-button:hover:not(.is-selected):not([disabled]) {
  background: rgba(79, 70, 229, 0.08); /* indigo hover */
  border-color: rgba(79, 70, 229, 0.25);
  color: #5858DA; /* accent */
}

/* Selected state */
.review-like-button.is-selected {
  background: rgba(79, 70, 229, 0.12);
  border-color: rgba(79, 70, 229, 0.32);
  color: #5858DA;
}

.review-like-button.is-selected .count {
  color: #5858DA;
}

.review-like-button:disabled,
.review-like-button[disabled] {
  opacity: 0.55;
  cursor: not-allowed;
}

.review-like-button.is-loading {
  opacity: 0.7;
  cursor: wait;
}
</style>

